exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".recaptcha-container[data-v-321d7c9a]{background-color:#fff;border-radius:8px;height:300px;width:600px;margin:0 auto 200px;padding:50px}h3[data-v-321d7c9a]{font-weight:600;text-transform:unset;margin-top:0}.recaptcha-container>div[data-v-321d7c9a]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-top:20px}", ""]);

// exports
